<template>


    <div class="containerRepresentante">

      

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
         </div>

         <div class="formulario">

           <div class="titleForm" style="display: inline-flex">
              <div style="width: 90%">

              <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações'" :TipoCliente="'Fundos'" :Sessao="'Declarações'" :SubSessao="'Declarações'"/>
              <h5>Aqui estão todos os documentos disponíveis para o seu perfil, clicar em ler os termos e aceitar as regras estabelecidas.</h5>
              
              <input class="field" style="width: 20%; margin-left: 15px; margin-bottom: 5px; background-color: white" type="text" placeholder="Pesquisar" v-model="filtroDocumento" @change="pesquisarDocumento">
              
              </div>
           </div>
          <div v-if="!requisicaoFinalizado" class="loading-overlay">
            <div class="spinner"></div>
          </div>
           <div v-if="requisicaoFinalizado" class="resumoForm">
            <div class="opcoesForm" v-if="listaDocumentos == null || listaDocumentos.length == 0">
                <h3>Nenhuma documento encontrado</h3>
            </div>
            <div v-if="listaDocumentos != null && listaDocumentos.length > 0">
              <table class="table">
                <thead>
                  <th style="width: 70%">Nome do documento</th>
                  <th style="width: 25%">Ações</th>
                  <th style="width: 5%">
                     <div class="widget icons" style="display: inline-flex">

                                        <a
                                            @click.stop.prevent="
                                                atualizarGridDeclaracoes()
                                            "
                                            class="ico__refresh"
                                            title="atualizar"       
                                            style="margin-top: 10px"                                     
                                        >
                                            <Icon icon="ico-refresh" />
                                            
                                        </a>
                     </div>
                    </th>
                </thead>
                <tbody>
                  <tr v-for="(documentoObj, index) in documentosFiltrados" :key="index">
                    <td>{{documentoObj.NomeDocumento}}</td>
                    <td>
                     <div class="widget icons produtos" style="display: inline-flex">

                        <button class="btnBlue" style="cursor: pointer; font-size: smaller; border-color: white;" v-if="!documentosCliente.some(p => p.TemplateId === documentoObj.TemplateId)" @click="abrirTermos(documentoObj.TemplateId)">Ler o termo</button>
                        <button class="btnBlue" style="cursor: default; background-color: #5E84C3; font-size: smaller; border-color: white; " v-if="documentosCliente.some(p => p.TemplateId == documentoObj.TemplateId) && !documentosCliente.some(p => p.TemplateId == documentoObj.TemplateId && p.StatusAssinatura == 'Pendente')" disabled="disabled">Termo aceito</button>
                        <button class="btnBlue" style="cursor: pointer; font-size: smaller; border-color: white; background-color: #252525; " @click="lerTermos(documentoObj.TemplateId, documentosCliente.some(p => p.TemplateId === documentoObj.TemplateId && p.StatusAssinatura == 'Pendente'))">Ver termo</button>
                        <button class="btnBlue" style="cursor: pointer; font-size: smaller; border-color: white; background-color: #252525; " v-if="documentosCliente.some(p => p.TemplateId === documentoObj.TemplateId && p.StatusAssinatura == 'Pendente')" @click="statusAssinatura(documentoObj.TemplateId)">Status da Assinatura</button>

                     </div> 
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>

         </div>



    </div>

    
</template>


<script>

import { mapGetters } from 'vuex';

export default {
    name: 'CadastroPF_Representantes',
    props: ['Edicao'],
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            listaDocumentosCliente: 'GET_LISTA_DOCUMENTOS_CLIENTE'
        }),
        documentosFiltrados() {
            if(this.filtroDocumento == ''){
              return this.listaDocumentos.filter(doc =>
                doc.TipoCliente.toLowerCase().includes('Investidor'.toLowerCase())
              );
            }

            if (this.filtroDocumento.length > 0) {
              return this.listaDocumentos.filter(doc =>
                doc.NomeDocumento.toLowerCase().includes(this.filtroDocumento.toLowerCase()) &&
                doc.TipoCliente.toLowerCase().includes('Investidor'.toLowerCase())
              );
            }


            return this.listaDocumentos;
        },
    },
    data() {
      return {
          filtroDocumento: '',
          requisicaoFinalizado: true,
          documentosCliente: [],
        }
    },
    created(){
       this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE', this.user.ClienteId);
       this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS');
    },
    mounted() {
      // Configura o intervalo para chamar a função a cada 10 segundos
      setInterval(() => {
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE', this.user.ClienteId);
      }, 10000);
    },
    watch:{
      listaDocumentosCliente(){
        this.requisicaoFinalizado = true;
        if(this.listaDocumentosCliente != null){
          this.documentosCliente = this.listaDocumentosCliente;
        }
      },
    },
    methods: {
      pesquisarDocumento(){

      },
      proximaEtapa(){
        this.$store.commit('SET_ETAPA_CADASTRO', 2);
      },
      abrirTermos(id){
        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", id);
        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
      },
      lerTermos(id){
        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", id);
        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", true);
      },
      statusAssinatura(id){
        var obj = this.documentosCliente.filter(p => p.TemplateId === id && p.StatusAssinatura == 'Pendente')[0]
        this.$store.commit("SET_MODAL_ASSINATURA_STATUS", obj.DeclaracaoGuid);
      },
      atualizarGridDeclaracoes(){
        this.requisicaoFinalizado = false;
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE', this.user.ClienteId);
      }

    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

    .btnBlueUpload{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    widows: 88px;
      cursor: pointer;
    
  }

  
.produtos  .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */ 
    cursor: pointer;
    
  }


  .produtos  .btnDefault {
    margin-left: 5px;
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: white;
    color: black;
    border: 1px solid black; /* Borda */
    border-radius: 8px; /* Raio de borda */
    cursor: pointer;
    
  }



.formulario{
  margin-top: 20px;
  width: 100%;
  margin-bottom: 10px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */
  border: 1px solid #EAECF0;
  border-radius: 8px; /* Raio de borda */


.titleForm{
  border-bottom: 1px solid #EAECF0;
  width: 100%;

    .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    width: 100px;
    cursor: pointer;
    
  }

    h3{
      margin-left: 20px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

    h5{
    margin-top: 5px;
    margin-left: 20px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
  }


}

.resumoForm{
  width: 100%;

.opcoesForm{
    margin-left: 30%;
    display: grid;
    justify-content: space-between;
    align-content: space-between;
    align-items: center;
    justify-items: center;
    padding: 30px 0px 30px 0px;
    
  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
  }

    img{
      height: 48px;
      width: 48px;
      
    }


  .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    width: 350px;
    cursor: pointer;
    
  }
}

}

}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
}

.categoriaAgrupamentoFormulario{
  width: 13%;
  margin-right: 15px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */

  span{
    font-weight: 400 !important;
    font-size: 13px;
    color: #667085;
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

                  .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }

 .field {
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 100%;
    /* gap: 8px; - 'gap' não é aplicável diretamente ao input, mas pode ser usado em um container */
}

 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .fieldInRadio{
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 55%;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>